export const getValue = (key: string) => {
  var data = localStorage.getItem(key);
  return data;
};

export const setValue = (key: string, data: string) => {
  localStorage.setItem(key, data);
};
